export enum EstadoFacturaAnticipadaDevolucion {
  Pendiente,
  Aprobado,
  Rechazado
}
